import { APIProvider } from "@vis.gl/react-google-maps";
import { FC } from "react";

import { WidgetContainerProps } from "src/dynamic-view-renderer/Widgets/WidgetContainer.tsx";
import { useT } from "src/internationalization";
import { Case } from "src/types/case";

import GoogleMapsWidgetError from "./GoogleMapsWidgetError";
import GoogleMapsWidgetMap from "./GoogleMapsWidgetMap";
import { GoogleStreetViewWidgetConfiguration } from "./GoogleStreetViewWidget";

export type GoogleMapsWidgetConfiguration = GoogleStreetViewWidgetConfiguration & {
  defaultCenter?: {
    lat: number;
    lng: number;
  };
  defaultZoom?: number;
  height?: string;
};

export type GoogleMapsWidgetProps = Omit<WidgetContainerProps, "children"> & {
  data?: {
    case: Case;
  };
  configuration?: GoogleMapsWidgetConfiguration;
  apiKey: string | null | undefined;
};

const GoogleMapsWidget: FC<GoogleMapsWidgetProps> = ({
  configuration,
  data,
  apiKey,
  ...containerProps
}) => {
  const t = useT();
  if (!apiKey) {
    return (
      <GoogleMapsWidgetError {...containerProps}>
        <div>{t("page.alertDetails.googleMaps.apiKey")}</div>
      </GoogleMapsWidgetError>
    );
  }

  if (data) {
    return (
      <APIProvider apiKey={apiKey}>
        <GoogleMapsWidgetMap
          {...containerProps}
          configuration={configuration}
          data={{ case: data.case }}
        />
      </APIProvider>
    );
  }
};

export default GoogleMapsWidget;
